import { Link } from "react-router-dom";
import "../styles/dashboard.css";

const ProjectCard = ({ project, onDelete }) => {
  return (
    <div className="project-card">
      <div>
        <h3>{project.name}</h3>
        <p>{project.description}</p>
      </div>
      <div className="project-card-footer">
        <Link to={`/project/${project.id}`} className="btn-primary">
          Open
        </Link>
        <button className="btn-secondary" onClick={() => onDelete(project.id)}>
          Delete
        </button>
      </div>
    </div>
  );
};

export default ProjectCard;
